import DayjsUtils from '@date-io/dayjs'
import {
	Box,
	Container, Divider,
	IconButton,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Tooltip from '@material-ui/core/Tooltip'
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import * as dayjs from 'dayjs'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useActions, useValues } from 'kea';
import AddIcon from '@material-ui/icons/Add';

import vehiclelogic from 'src/store/vehicle'
import { rtrackerslogic } from 'src/store/report'

const initialTrackersDataParam = {
	start: dayjs().subtract(3, 'month').startOf('month'),
	stop: dayjs().subtract(1, 'month').endOf('month')
}

const MilageDataDialog = props => {
	const { enqueueSnackbar } = useSnackbar();

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll: vehicleFetchAll } = useActions(vehiclelogic);

	const { fetch } = useActions(rtrackerslogic);

	const [trackersDataParam, setTrackersDataParam] = useState(initialTrackersDataParam);
	const [open, setOpen] = React.useState(false);


	useEffect(() => {
		vehicles ?? vehicleFetchAll();
	}, []) // eslint-disable-line

	if (vehicles === null) {
		return (
			<></>
		)
	}

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleAdd = event => {
		if (dayjs(trackersDataParam.start).isAfter(trackersDataParam.stop)) {
			enqueueSnackbar('Please enter correct dates', { variant: 'error' });
			return
		}
		addDataHandler(trackersDataParam);
		setTrackersDataParam(initialTrackersDataParam);
		handleClose();
	}

	const handleChange = (key, value) => {
		let updatedParams = { ...trackersDataParam };
		updatedParams[key] = value;
		setTrackersDataParam(updatedParams);
	}
	const handleHotKey = (period, value, lastdays = true) => {
		let updatedParams = { ...trackersDataParam };
		if (period === 'month') {
			updatedParams.start = dayjs().subtract(value, 'month').startOf('month');
			updatedParams.stop = dayjs().subtract(value, 'month').endOf('month')
		} else if (period === 'week') {
			updatedParams.start = dayjs().subtract(value, 'week').startOf('week');
			updatedParams.stop = dayjs().subtract(value, 'week').endOf('week');
		} else if (period === 'day') {
			updatedParams.start = dayjs().subtract(value, 'day').startOf('day');
			updatedParams.stop = lastdays ? dayjs().subtract(value, 'day').endOf('day') : dayjs().endOf('day');
		}
		setTrackersDataParam(updatedParams);
	}

	const addDataHandler = (new_data) => {
		fetch(new_data);
	}

	return (
		<>
			<Tooltip title="Generate Report">
				<IconButton aria-label="add" onClick={handleClickOpen}>
					<AddIcon />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth='xl'
			>
				<DialogTitle id="form-dialog-title">Generate Report</DialogTitle>
				<DialogContent>
					<div style={{ width: '800px', }}></div>
				</DialogContent>
				<DialogActions>
					<Container maxWidth={false}>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
									<Button onClick={() => handleHotKey('day', 30, false)} color="primary">
										Last 30 Days
									</Button>
									<Button onClick={() => handleHotKey('month', 1)} color="primary">
										Last Month
									</Button>
									<Button onClick={() => handleHotKey('week', 1)} color="primary">
										Last Week
									</Button>
									<Button onClick={() => handleHotKey('day', 1)} color="primary">
										Last Day
									</Button>
								</div>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
									<div style={{ minWidth: '50px' }} >
										<MuiPickersUtilsProvider utils={DayjsUtils}>
											<DatePicker
												autoOk
												variant="inline"
												label="Start"
												format="DD/MM/YYYY"
												value={trackersDataParam.start}
												onChange={(value) => handleChange('start', value)}
												disableFuture
											/>
										</MuiPickersUtilsProvider>
									</div>
									<div style={{ minWidth: '50px' }} />
									<MuiPickersUtilsProvider utils={DayjsUtils}>
										<DatePicker
											autoOk
											variant="inline"
											label="Stop"
											format="DD/MM/YYYY"
											value={trackersDataParam.stop}
											onChange={(value) => handleChange('stop', value)}
											disableFuture
											minDate={trackersDataParam.start}
											minDateMessage={'Date should not be before \'Start date\''}
										/>
									</MuiPickersUtilsProvider>
								</div>
							</div>
							<Divider />
						</Box>
						<Box>
							<div style={{ paddingTop: '15px', paddingBottom: '15px', width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
								<Button onClick={handleClose} color="primary">
									Cancel
								</Button>
								<Button onClick={handleAdd} color="primary">
									Generate
								</Button>
							</div>
						</Box>
					</Container>
					{/* </Paper> */}
					<Divider />
				</DialogActions>
			</Dialog >
		</>
	)
}

MilageDataDialog.propTypes = {
}

export default MilageDataDialog
